// Venue-local clock synced from the backend.
//
// The booking APIs return server_now: the current time at the venue, expressed as a
// plain wall-clock string (YYYY-MM-DDTHH:mm:ss, no timezone suffix). Parsing that as
// a local Date yields a Date that represents the venue's wall clock in the device's
// frame, which is exactly the frame the slot availability math works in (slot
// booking_date/start_time are venue wall-clock strings parsed the same way).
//
// We store the offset from the device clock rather than the value itself so the
// corrected time stays fresh between fetches, and so a device with the wrong clock
// or in a different timezone can't shift which slots appear bookable.

let offsetMs = null

export function syncServerNow(serverNow) {
  if (!serverNow) return
  const parsed = new Date(serverNow)
  if (isNaN(parsed.getTime())) return
  offsetMs = parsed.getTime() - Date.now()
}

// Venue wall-clock "now". Falls back to the device clock until the first
// response carrying server_now arrives.
export function getNow() {
  if (offsetMs === null) return new Date()
  return new Date(Date.now() + offsetMs)
}
